import React from 'react';

const Loader = (props) => {
	return <div className="loader"><div className="loader-wheel"></div></div>;
}

export default Loader;
